export const formatAxisValue = (value: number): string => {
  const absValue = Math.abs(value);
  const sign = value < 0 ? "-" : "";
  if (absValue >= 1000000000) {
    const v = absValue / 1000000000;
    return (
      sign + (v >= 10 ? v.toFixed(0) : v.toFixed(1)).replace(/\.0$/, "") + "B"
    );
  } else if (absValue >= 1000000) {
    const v = absValue / 1000000;
    return (
      sign + (v >= 10 ? v.toFixed(0) : v.toFixed(1)).replace(/\.0$/, "") + "M"
    );
  } else if (absValue >= 1000) {
    const v = absValue / 1000;
    return (
      sign + (v >= 10 ? v.toFixed(0) : v.toFixed(1)).replace(/\.0$/, "") + "K"
    );
  } else if (absValue < 10 && absValue > 0) {
    if (absValue < 0.01) return value.toFixed(4);
    else if (absValue < 0.1) return value.toFixed(3);
    else if (absValue < 1) return value.toFixed(2);
    else return value.toFixed(1);
  } else if (value === 0) return "0";
  else if (value % 1 === 0) return sign + Math.round(absValue).toString();
  return value.toFixed(1);
};
